 
import { BreadcrumbComponent, ConfirmationPopup, Loader, Modal, useToastMessage } from 'ccs-ui-components';
import { isEqual } from 'lodash';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ACTIVE } from '../../../../constants';
import { IFormFieldData, IMaintenanceRequestData } from '../../../../models';
import { AppDispatch, useSelector } from '../../../../store/AppStore';
import {
  saveMaintenanceRequest
} from '../../../../store/actions/sagaActions/schedule-maintenance/SaveMaintenanceSagaActions';
import { getSmLogHistoryRequest } from '../../../../store/actions/sagaActions/schedule-maintenance/SmLogHistorySagaAction';
import { cleargetServices, getServicesRequest } from '../../../../store/actions/sagaActions/services/GetServicesSagaActions';
import { clearSaveMaintenance } from '../../../../store/reducer/schedule-maintenance/SaveMaintenanceReducer';
import { clearSmLogHistory, getSmLogHistorySuccess } from '../../../../store/reducer/schedule-maintenance/SmLogHistoryReducer';
import { ServiceRequest } from '../../../../store/sagas/services/GetServicesSaga';
import ImpactedServicesForm from '../impacted-services-form/ImpactedServicesForm';
import { SCHEDULE_MAINTENANCE_MODE, SCHEDULE_MAINTENANCE_ROUTE, getMaintenanceNameFromUrl, getModeFromUrl, setImpactedServices } from './utilities/AddScheduleMaintenanceUtils';

export enum maintenanceService {
  VALID = 'VALID',
  INVALID = 'INVALID',
}

const ScheduledMaintenanceDetailsWrapper: React.FC = () => {
  /* Local states */
  const [selArray, setSelArray] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [disableSave, setDisableSave] = useState(true);
  const [isView, setIsView] = useState(false);
  const [isViewServices, setIsViewServices] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [services, setServices] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [enableUpdateButton, setEnableUpdateButton] = useState(false);
  const [deleteDataItem, setDeleteDataItem] = useState({ serviceName: '', serviceVersion: '' });
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [isSticky, setIsSticky] = useState(false);
  const [headerText, setHeaderText] = useState(SCHEDULE_MAINTENANCE_MODE.ADD);
  const [invalidMaintenanceService, setInvalidMaintenanceService] = useState(maintenanceService.VALID);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState<boolean>(true);
  const [payloadData, setPayloadData] = useState<IMaintenanceRequestData>({
    impactedServices: [{ serviceName: '', serviceVersion: '' }],
    maintenanceName: '',
    maintenanceNameValid: true,
    usersEmailValid: true,
    message: '',
    startTimestamp: '',
    endTimestamp: '',
    usersEmail: [],
    serviceType: ''
  });
  /* Local Variables */
  const route = useLocation();
  const maintenanceModeFromUrl = getModeFromUrl();
  const maintenanceNameFromUrl = getMaintenanceNameFromUrl();
  // Hooks
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { SmLogHistoryDetails: data, isLoading: smDataIsloading, errorMessage: smLogErrorMessage } = useSelector((state) => state.LogHistory);
  const { success: successToast, failure, renderToast } = useToastMessage();
  /* Get Data from the store */
  const { ServicesDetails } = useSelector((state: any) => state?.MaintenanceServicesReducer);
  let { isLoading } = useSelector((state: any) => state?.MaintenanceServicesReducer);

  const errorTextConstants = {
    maintenance_service_invalid: translate('add_sm_wrapper.txt_service_error')
  };

  useEffect(() => {
    dispatch(clearSaveMaintenance());
    dispatch(clearSmLogHistory());
    if (maintenanceModeFromUrl.toUpperCase() === SCHEDULE_MAINTENANCE_MODE.VIEW.toUpperCase()) {
      setIsView(true);
      setIsEdit(false);
      setHeaderText(SCHEDULE_MAINTENANCE_MODE.VIEW);
    } else if (maintenanceModeFromUrl.toUpperCase() === SCHEDULE_MAINTENANCE_MODE.EDIT.toUpperCase()) {
      setIsView(false);
      setIsViewServices(false);
      setIsEdit(true);
      setHeaderText(SCHEDULE_MAINTENANCE_MODE.EDIT);
    }
    if (maintenanceNameFromUrl.length > 0 && maintenanceModeFromUrl.length > 0) {
      dispatch(getSmLogHistoryRequest({ maintenanceName: maintenanceNameFromUrl, status: 'ACTIVE' }));
    }
    const windowScrollStickyHeader = () => {
      const sticky = 10;
      if (window.scrollY > sticky) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', windowScrollStickyHeader);

    return (() => {
      window.removeEventListener('scroll', windowScrollStickyHeader);
    });
  }, []);

  useEffect(() => {
    if (data[0]?.maintenanceName) {
      const payload: IMaintenanceRequestData = {
        maintenanceName: data[0]?.maintenanceName,
        message: data[0]?.message,
        usersEmail: [...data[0].usersEmail],
        startTimestamp: data[0]?.startTimestamp,
        endTimestamp: data[0]?.endTimestamp,
        impactedServices: data[0]?.impactedServices?.map((service) => ({
          serviceName: service?.serviceName,
          serviceVersion: service?.serviceVersion?.toString(),
        })),
        isEdit: true,
        maintenanceNameValid: true,
        usersEmailValid: true,
        serviceType: data[0].serviceType
      };
      setIsView(maintenanceModeFromUrl.toUpperCase() === translate('add_sm_wrapper.txt_action_view').toUpperCase());
      setIsViewServices(maintenanceModeFromUrl.toUpperCase() === translate('add_sm_wrapper.txt_action_view').toUpperCase());
      setIsEdit(maintenanceModeFromUrl.toUpperCase() === translate('add_sm_wrapper.txt_action_edit').toUpperCase());
      setPayloadData(payload);
      setSelArray(data[0]?.impactedServices);
    }
  }, [data]);

  // updates the search value for impacted service list
  useEffect(() => {
    if (ServicesDetails?.services?.length > 0 && searchValue?.length > 2) {
      const services = ServicesDetails.services.map((x: any) => ({
        ...x,
        isChecked: selArray?.some((i) => (x.serviceName === i.serviceName && x.version === i.serviceVersion)) || false,
      }));
      setServices(services);
      isLoading = false;
    } else {
      setServices([]);
    }
  }, [ServicesDetails, searchValue]);

  const { saveMaintenanceDetails, success, isLoading: isSaveLoading, errorMessage } = useSelector((state: any) => state?.SaveMaintenanceReducer);

  useEffect(() => {
    if (selArray?.length > 0) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
    checkShouldUpdateEnable();
  }, [selArray?.length]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (success) {
      setDisableSave(true);
      navigate(`${SCHEDULE_MAINTENANCE_ROUTE.SCHEDULE_MAINTENANCE_HOME}/view/${saveMaintenanceDetails?.maintenanceName}`, {
        state: {
          path: route.search
        }
      });
      setIsView(true);
      setIsEdit(false);
      setIsViewServices(true);
      dispatch(getSmLogHistorySuccess(saveMaintenanceDetails));
      if (maintenanceModeFromUrl.toUpperCase() === SCHEDULE_MAINTENANCE_MODE.EDIT.toUpperCase()) {
        successToast(
          translate('add_sm_wrapper.txt_success'),
          translate('add_sm_wrapper.txt_update_success_desc')
        );
      } else {
        successToast(
          translate('add_sm_wrapper.txt_success'),
          translate('add_sm_wrapper.txt_success_desc')
        );
      }
      setShowConfirmationPopup(false);
    }
    if (errorMessage?.error?.length > 0 || smLogErrorMessage?.length > 0) {
      if (maintenanceModeFromUrl.toUpperCase() === SCHEDULE_MAINTENANCE_MODE.EDIT.toUpperCase()) {
        failure(
          translate('add_sm_wrapper.txt_error'),
          translate('add_sm_wrapper.txt_update_error_desc')
        );
      } else {
        failure(
          translate('add_sm_wrapper.txt_error'),
          translate('add_sm_wrapper.txt_error_desc')
        );
      }
      setDisableSave(false);
    }
  }, [success, errorMessage, isEdit, isView, isSaveLoading]);

  /**
   * @method handleSelect
   * @description Handles the selected checkbox functionality from impacted service list
   */
  const handleSelect = (
    data: any,
    event: React.FormEvent<HTMLInputElement>
  ) => {
    const servicesList: any = services;
    const index = servicesList?.findIndex((x: any) => x === data);
    if (event.currentTarget.checked) {
      const existingItems = selArray?.filter(
        (x) => (x.serviceName === data.serviceName && x.serviceVersion === data.version)
      );

      if (existingItems?.length > 0) {
        return;
      }
      if (index >= 0) {
        servicesList[index].isChecked = true;
        setServices(servicesList);
      }

      const impactedServices = {
        serviceName: data?.serviceName,
        serviceVersion: data?.version,
      };

      if (selArray) setSelArray((current) => [...current, impactedServices]);
      else setSelArray([impactedServices]);
    } else {
      if (index >= 0) {
        servicesList[index].isChecked = false;
        setServices(servicesList);
      }
      setSelArray((current) => current?.filter((i) => !(data.serviceName === i.serviceName && data.version === i.serviceVersion)));
    }
    unableCreate();
  };

  const handleDelete = (data: any) => {
    setShowDeleteModal(true);
    setDeleteDataItem(data);
  };

  const confirmDelete = () => {
    setShowDeleteModal(false);
    setDeleteLoader(true);
    if (selArray?.length > 0) {
      const servicesList: any = services;
      const serviceListName = servicesList.map((x: any) => (x.serviceName));

      const index = serviceListName.findIndex((x: any) => x === deleteDataItem.serviceName);

      if (index >= 0) {
        servicesList[index].isChecked = false;
        setServices(servicesList);
      }
      setSelArray((current) => current?.filter((x) => x !== deleteDataItem));
    }
    unableCreate();
    setDeleteLoader(false);
  };
  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  useEffect(() => {
    const payload: ServiceRequest = {
      serviceType: String(payloadData.serviceType),
      services: [
        {
          serviceName: searchValue
        }
      ],
      status: [ACTIVE]
    };
    if (searchValue?.length >= 3) {
      dispatch(getServicesRequest(payload));
    } else if (searchValue?.length < 3) {
      dispatch(cleargetServices());
    }
  }, [searchValue]);

  useEffect(() => {
    if (ServicesDetails?.services?.length === 0) {
      setInvalidMaintenanceService(maintenanceService.INVALID);
    } else setInvalidMaintenanceService(maintenanceService.VALID);
  }, [ServicesDetails, searchValue]);

  const getServices = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleFormData = (data: IFormFieldData) => {
    const dataPayload: IMaintenanceRequestData = payloadData;
    switch (data.name) {
      case 'name':
        dataPayload.maintenanceName = data.value;
        dataPayload.maintenanceNameValid = (data.invalidMaintenanceName === 'VALID');
        dataPayload.usersEmailValid = (data.invalidMaintenanceEmail === 'VALID');
        break;
      case 'message':
        dataPayload.message = data.value;
        dataPayload.maintenanceNameValid = (data.invalidMaintenanceName === 'VALID');
        dataPayload.usersEmailValid = (data.invalidMaintenanceEmail === 'VALID');
        break;
      case 'email':
        dataPayload.usersEmail = [...(data.value).split(',')];
        dataPayload.maintenanceNameValid = (data.invalidMaintenanceName === 'VALID');
        dataPayload.usersEmailValid = (data.invalidMaintenanceEmail === 'VALID');
        break;
      case 'fromDate':
        dataPayload.startTimestamp = data.value;
        dataPayload.maintenanceNameValid = (data.invalidMaintenanceName === 'VALID');
        dataPayload.usersEmailValid = (data.invalidMaintenanceEmail === 'VALID');
        break;
      case 'toDate':
        dataPayload.endTimestamp = data.value;
        dataPayload.maintenanceNameValid = (data.invalidMaintenanceName === 'VALID');
        dataPayload.usersEmailValid = (data.invalidMaintenanceEmail === 'VALID');
        break;
      case 'servicetype':
        dataPayload.serviceType = data.value;
        if (data.value) setIsViewServices(false);
        dataPayload.maintenanceNameValid = (data.invalidMaintenanceName === 'VALID');
        dataPayload.usersEmailValid = (data.invalidMaintenanceEmail === 'VALID');
        break;
      default:
        break;
    }
    setPayloadData(dataPayload);
    unableCreate();
    checkShouldUpdateEnable();
  };

  const saveMaintenanceHandler = () => {
    delete payloadData.maintenanceNameValid;
    setPayloadData(setImpactedServices(isEdit, selArray, payloadData));
    dispatch(saveMaintenanceRequest(payloadData));
    setDisableSave(true);
    setIsView(true);
    setIsEdit(false);
  };

  const errorText = () => {
    if (invalidMaintenanceService === maintenanceService.INVALID) {
      return errorTextConstants.maintenance_service_invalid;
    }
    return '';
  };
  const unableCreate = () => {
    if (
      !payloadData.maintenanceName
      || !payloadData.message
      || !payloadData.endTimestamp
      || !payloadData.startTimestamp
      || !payloadData.usersEmail
      || payloadData.usersEmail.length === 0
      || !payloadData.maintenanceNameValid
      || !payloadData.usersEmailValid
    ) setDisableSave(true);
    else setDisableSave(false);
  };

  const checkShouldUpdateEnable = () => {
    const currentFormData = {
      maintenanceName: payloadData.maintenanceName,
      message: payloadData.message,
      endTimestamp: payloadData.endTimestamp,
      startTimestamp: payloadData.startTimestamp,
      usersEmail: payloadData.usersEmail,
      selArray
    };
    const clonedReducerData = {
      maintenanceName: data[0]?.maintenanceName,
      message: data[0]?.message,
      endTimestamp: data[0]?.endTimestamp,
      startTimestamp: data[0]?.startTimestamp,
      usersEmail: data[0]?.usersEmail,
      selArray: data[0]?.impactedServices
    };
    const isDataEqual = isEqual(currentFormData, clonedReducerData);
    if (isDataEqual) {
      setEnableUpdateButton(true);
    } else {
      setEnableUpdateButton(false);
    }
  };

  const cancelHandler = () => {
    dispatch(cleargetServices());
    const queryParam = route.state?.path;
    navigate(`${SCHEDULE_MAINTENANCE_ROUTE.SCHEDULE_MAINTENANCE_HOME}${queryParam || ''}`);
  };
  const handleEdit = () => {
    dispatch(clearSaveMaintenance());
    navigate(`${SCHEDULE_MAINTENANCE_ROUTE.SCHEDULE_MAINTENANCE_HOME}/edit/${maintenanceNameFromUrl}`, {
      state: {
        path: route.search
      }
    });
    setIsView(false);
    setIsEdit(true);
    setSearchValue('');
    dispatch(getSmLogHistoryRequest({ maintenanceName: maintenanceNameFromUrl, status: 'ACTIVE' }));
  };

  return (
    <>
      <Col md={{ span: 10, offset: 1 }}>
        <BreadcrumbComponent />
      </Col>
      {/* <ScheduledMaintenanceDetailsWrapper data={route} /> */}
      <div className="container">
        {!isView && showConfirmationPopup && (<ConfirmationPopup />)}
        <Loader
          show={deleteLoader || isSaveLoading || smDataIsloading}
        />
        {renderToast()}
        <Modal
          modalTitle={translate('add_sm_wrapper.txt_confirm_delete')}
          modalBody={translate('add_sm_wrapper.txt_delete_message_desc')}
          modalShow={showDeleteModal}
          btnSaveText={String(translate('add_sm_wrapper.txt_delete'))}
          btnCloseText={String(translate('add_sm_wrapper.txt_cancel'))}
          onSaveModal={confirmDelete}
          onCloseModal={cancelDelete}
          alignToCentre
          disableSaveBtn={false}
          disableCloseBtn={false}
          type="warning"
        />

        <ImpactedServicesForm
          cancelHandler={cancelHandler}
          isView={isView}
          disableSave={disableSave}
          isDisable={isDisable}
          saveMaintenanceHandler={saveMaintenanceHandler}
          handleFormData={handleFormData}
          searchValue={searchValue}
          getServices={getServices}
          isViewServices={isViewServices}
          handleEdit={handleEdit}
          isLoading={isLoading}
          invalidMaintenanceService={invalidMaintenanceService}
          errorText={errorText}
          services={services}
          handleSelect={handleSelect}
          selArray={selArray}
          handleDelete={handleDelete}
          isSticky={isSticky}
          headerText={headerText}
          isEdit={isEdit}
          enableUpdateButton={enableUpdateButton}
        />
      </div>
    </>
  );
};
export default ScheduledMaintenanceDetailsWrapper;
